import { useEffect, useState } from "react";
import './DashboardOptions.scss';
import {
  Grid,
  Box,
  Card,
  CardContent,
  Typography,
  Container,
  TextField,
} from "@mui/material";
import { Link } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useAuth, getAppTheme } from "../../services/authContext";
import { Article, ContactPhoneSharp } from "@mui/icons-material";

const DashboardOptions = () => {
  const { loginStatus } = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const mode = useSelector((state) => state.theme.mode);
  const theme = getAppTheme(mode);
  const [filteredSections, setFilteredSections] = useState([
    {  
      title: "General Section",
      cardConfig: [
        // {
        //   link: '/fd-marketplace',
        //   icon: <SavingsIcon />,
        //   colorOne: [20, 90, 50],
        //   colorTwo: [20, 90, 50],
        //   text: 'FD Marketplace',
        // },
        // {
        //   link: '/fd-calculator',
        //   icon: <CalculateIcon />,
        //   colorOne: [10, 40, 70],
        //   colorTwo: [10, 40, 70],
        //   text: 'FD Calculator',
        // },
        // {
        //   link: '/fd-booking',
        //   icon: <TaskAltIcon />,
        //   colorOne: [100, 20, 80],
        //   colorTwo: [100, 20, 80],
        //   text: 'Book FD',
        // },
        // {
        //   link: '/kyc-verification',
        //   icon: <VerifiedUserIcon />,
        //   colorOne: [0, 123, 255],
        //   colorTwo: [0, 123, 255],
        //   text: 'KYC Verification',
        // },
        // {
        //   link: '/fd-documents',
        //   icon: <UploadFileIcon />,
        //   colorOne: [153, 102, 255],
        //   colorTwo: [102, 51, 255],
        //   text: 'Upload Docs',
        // },
        // {
        //   link: '/fd-track',
        //   icon: <SearchIcon />,
        //   colorOne: [255, 153, 51],
        //   colorTwo: [204, 102, 0],
        //   text: 'Track FDs',
        // },
        {
          link: '/admin/blog',
          icon: <Article/>,
          colorOne: [255, 153, 51],
          colorTwo: [204, 102, 0],
          text: 'Blogs',
        },
        {
          link: '/admin/contact',
          icon: <ContactPhoneSharp/>,
          colorOne: [255, 153, 51],
          colorTwo: [204, 102, 0],
          text: 'Contact Leads',
        },
      ],
    },
  ]);

  useEffect(() => {

    const filtered = filteredSections
      .map((section) => ({
        ...section,
        cardConfig: section.cardConfig.filter((card) =>
          card.text.toLowerCase().includes(searchTerm.toLowerCase())
        ),
      }))
      .filter((section) => section.cardConfig.length > 0);

    setFilteredSections(filtered);
  }, [loginStatus, searchTerm, filteredSections]);

  return (
    <ThemeProvider theme={theme}>
      {loginStatus?.user?.staff_type ==="admin" ?(
      <div
        className="Dashboard"
        data-testid="Dashboard"
        style={{ marginBottom: "57px", paddingBottom: "80px", width: "100%" }}
      >
        {/* Search Box */}
        <Container maxWidth="lg" sx={{ marginBottom: "20px", marginTop: "80px" }}>
          <Typography
                variant="h5"
                sx={{
                  textAlign: "center",
                  color: theme.palette.heading.h6,
                  padding: "10px 20px",
                  fontWeight: "600",
                  letterSpacing: "1px",
                  marginBottom:"20px"
                  
                }}
              >
                Make Loan Eazy Admin Panel
              </Typography>
          <TextField
            label="Search Features"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Container>

        <Container maxWidth="lg" sx={{ flexGrow: 1 }}>
          {filteredSections.map((section, sectionIndex) => (
            <Box key={sectionIndex} sx={{ flexGrow: 1, padding: "8px" }}>
              <Typography
                variant="h6"
                sx={{
                  textAlign: "left",
                  color: theme.palette.heading.h6,
                  padding: "10px 20px",
                  fontWeight: "600",
                  letterSpacing: "1px",
                  borderBottom: "2px solid #bdc3c7",
                }}
              >
                {section.title}
              </Typography>

              <Grid container spacing={2} sx={{ marginTop: "16px" }} justifyContent="start">
                {section.cardConfig.map((card, cardIndex) => (
                  <Grid item xs={4} sm={4} md={3} lg={2} key={cardIndex}>
                    <Link to={card.link} className="linkTag" style={{ textDecoration: 'none' }}>
                      <Card
                        sx={{
                          textAlign: 'center',
                          padding: '16px 12px',
                          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
                          ':hover': { borderBottom: mode === 'light' ? '0px solid #333' : '0px solid #222' },
                          borderRadius: '8px',
                          transition: 'all 0.3s ease-in-out',
                          height: { xs: '90px', sm: '110px' },
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          borderBottom: mode === 'light' ? '3px solid #aaa' : '3px solid #333',
                        }}
                      >
                        <CardContent
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%',
                          }}
                        >
                          <Typography
                            variant="h5"
                            sx={{
                              width: { xs: '35px', sm: '50px' },
                              height: { xs: '35px', sm: '50px' },
                              objectFit: 'contain',
                              marginTop: "10px"
                            }}
                          >
                            {card.icon}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: { xs: '11.2px', sm: '14px' },
                              fontWeight: '700',
                              marginTop: "10px"
                            }}
                          >
                            {card.text}
                          </Typography>
                        </CardContent>
                      </Card>
                    </Link>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Container>
      </div>) : "Nothing Here !"
      }
    </ThemeProvider>
  );
};

export default DashboardOptions;
